<template>
  <o-sales-view
    nav-bar-title="MIVB"
    title="Unregistered MOBIB card"
    image="images/mivb-header.jpg"
    :show-button="false"
  >
    <template v-slot:custom>
      <o-section>
        <o-info-block icon="mobib">
          <p>
            It looks like your MOBIB card
            <strong>“My red MOBIB card”</strong> is not registered with MIVB.
            You can register your MOBIB card by going to
            <a href="#">the MIVB website</a>.
          </p>
        </o-info-block>
      </o-section>
    </template>
  </o-sales-view>
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
export default {
  name: 'MIVB Error',
  components: {
    OSalesView
  }
}
</script>
